require('./bootstrap')

var helpers = require('./helpers').default
import Vue from 'vue/dist/vue'
window.Vue = Vue
window.Vue.use(require('vue-cookies'))
window.queryString = require('query-string')
var lang = require('lang.js')

var WOW = require('wow.js')
window.wow = new WOW({
  offset: 50,
}).init()

import Popover from 'vue-js-popover'
Vue.use(Popover)

// Routes
var routes = require('./laravel-routes-js').default.load([
  'api.realtime',
  'api.frontend',
  'frontend',
  'pdf',
  'api.checkout',
  'api.bookings',
])
window.route = (...args) => routes.route(...args)

// Require
require('./common/jquery-animatecss-extension.js')
window.Fingerprint2 = require('fingerprintjs2')
require('./frontend/bootstrap-affix.js')
require('./frontend/nav.js')
require('./frontend/spotlight.js')
require('./frontend/tracking.js')
require('./frontend/search.js')
require('./frontend/wellness-page.js')
require('password-strength-meter/dist/password.min.js')
require('./common/autoloadTabs')
require('./common/jquery.detect_swipe.js')
require('./frontend/trip-page.js')
require('./frontend/blog.js')
require('./frontend/cards.js')
require('./frontend/pages.js')
var moment = require('moment')
var momentRange = require('moment-range')
window.moment = momentRange.extendMoment(moment)
require('jquery-date-range-picker/src/jquery.daterangepicker.js')

window.copy = require('copy-to-clipboard')

var { loadProgressBar } = require('axios-progress-bar')
loadProgressBar()

// Body scroll
window.bodyScrollLock = require('body-scroll-lock')
window.disableBodyScroll = window.bodyScrollLock.disableBodyScroll
window.enableBodyScroll = window.bodyScrollLock.enableBodyScroll

var translations = require('./vue-translations.js')
window.Lang = new lang()
Lang.setLocale(appLocale)
Lang.setMessages(translations)
export default Lang

Vue.filter('trans', (...args) => {
  return Lang.get(...args)
})

Vue.filter('choice', (...args) => {
  return Lang.choice(...args)
})

Vue.filter('formatPrice', function (value) {
  value = parseFloat(value, 10)
  if (Math.floor(value) === value) {
    return helpers.number_format(value, 0, ',', '.')
  }

  return helpers.number_format(value, 2, ',', '.')
})

Vue.filter('formatPriceRounded', function (value) {
  value = Math.round(parseFloat(value, 10))

  return helpers.number_format(value, 0, ',', '.')
})

Vue.filter('formatRatings', function (value) {
  value = parseFloat(value, 10)
  if (Math.floor(value) === value) {
    return helpers.number_format(value, 0, ',', '.')
  }

  return helpers.number_format(value, 1, ',', '.')
})

Vue.filter('formatNumber', function (value) {
  value = parseFloat(value, 10)
  if (Math.floor(value) === value) {
    return helpers.number_format(value, 0, ',', '.')
  }

  return helpers.number_format(value, 2, ',', '.')
})

Vue.filter('strSlug', (title) => {
  var slug = ''
  // Change to lower case
  var titleLower = title.toLowerCase()
  // Letter "e"
  slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e')
  // Letter "a"
  slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a')
  // Letter "o"
  slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o')
  // Letter "u"
  slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u')
  // Letter "d"
  slug = slug.replace(/đ/gi, 'd')
  // Trim the last whitespace
  slug = slug.replace(/\s*$/g, '')
  // Change whitespace to "-"
  slug = slug.replace(/\s+/g, '-')

  return slug
})

/* Trip page */
Vue.component(
  'trip-photo-slideshow',
  require('./components/frontend/TripPhotoSlideshow.vue').default
)

/* Trips search result */
Vue.component(
  'trips-search-results',
  require('./components/frontend/TripsSearchResults.vue').default
)

/* Trips search */
Vue.component(
  'trips-search-home',
  require('./components/frontend/trips/SearchHome.vue').default
)
Vue.component(
  'trips-search-results',
  require('./components/frontend/trips/SearchResults.vue').default
)

/* Trip tile */
Vue.component(
  'trip-tile',
  require('./components/frontend/TripTile.vue').default
)

/* Trip price diagram */
Vue.component(
  'trip-price-diagram',
  require('./components/frontend/TripPriceDiagram.vue').default
)

/* Trip offers */
Vue.component(
  'trip-offers',
  require('./components/frontend/TripOffers.vue').default
)

/* Trip offer tile */
Vue.component(
  'trip-offer-tile',
  require('./components/frontend/TripOfferTile.vue').default
)

/* Location map */
Vue.component(
  'location-map',
  require('./components/frontend/LocationMap.vue').default
)

/* Trips comparison */
Vue.component(
  'trips-comparison',
  require('./components/frontend/TripsComparison.vue').default
)

/* Checkout */
Vue.component('checkout', require('./components/frontend/Checkout.vue').default)

/* Checkout: Voucher code card */
Vue.component(
  'checkout-voucher-code-card',
  require('./components/frontend/checkout/VoucherCodeCard.vue').default
)

/* Pay form */
Vue.component(
  'pay-form',
  require('./components/frontend/checkout/PayForm.vue').default
)

/* Pay status */
Vue.component(
  'pay-status',
  require('./components/frontend/checkout/PayStatus.vue').default
)

/* Confirmation page */
Vue.component(
  'confirmation-page',
  require('./components/frontend/checkout/ConfirmationPage.vue').default
)

/* Nav search */
Vue.component(
  'nav-search',
  require('./components/frontend/NavSearch.vue').default
)

/* Support contact form */
Vue.component(
  'support-contact-form',
  require('./components/frontend/support/ContactForm.vue').default
)

/* Support help articles search */
Vue.component(
  'support-help-articles-search',
  require('./components/frontend/support/HelpArticlesSearch.vue').default
)

/* Realtime visitors */
Vue.component(
  'realtime-visitors',
  require('./components/frontend/RealtimeVisitors.vue').default
)

/* Booking change */
Vue.component(
  'booking-change',
  require('./components/frontend/BookingChange.vue').default
)

/* Booking cancellation */
Vue.component(
  'booking-cancellation',
  require('./components/frontend/BookingCancellation.vue').default
)

/* Availability calendar */
Vue.component(
  'availability-calendar',
  require('./components/frontend/AvailabilityCalendar.vue').default
)

/* Hotel partner form */
Vue.component(
  'hotel-partner-form',
  require('./components/frontend/partners/HotelPartnerForm.vue').default
)

/* Recall modal */
Vue.component(
  'recall-modal',
  require('./components/frontend/partners/RecallModal.vue').default
)

/* Recall modal */
Vue.component(
  'trip-hero',
  require('./components/frontend/trips/Hero.vue').default
)

/* Trip destinations map */
Vue.component(
  'trip-destinations-map',
  require('./components/frontend/TripDestinationsMap.vue').default
)

/* Trip destination modal */
Vue.component(
  'trip-destination-modal',
  require('./components/frontend/trips/TripDestinationModal.vue').default
)

Vue.component(
  'accommodation-travel-picker',
  require('./components/frontend/trips/search/TravelPeriodPicker.vue').default
)

// Vue.component(
//     'floating-checkout',
//     require('./components/frontend/FloatingCheckout.vue').default
//     );

Vue.component(
  'property-booking-case',
  require('./components/frontend/trips/PropertyBookingCase.vue').default
)

Vue.component(
  'booking-number',
  require('./components/frontend/checkout/BookingNumber.vue').default
)

Vue.component(
  'amenity-card',
  require('./components/frontend/trips/AmenityCard.vue').default
)

Vue.component(
  'amenity-cards',
  require('./components/frontend/trips/AmenityCards.vue').default
)

Vue.component(
  'checkout-review',
  require('./components/frontend/checkout/CheckoutReview.vue').default
)

Vue.component(
  'manual-redemption-form-heide-park',
  require('./components/frontend/ManualRedemptionFormHeidePark.vue').default
)

Object.defineProperty(Vue.prototype, '$lodash', { value: window._ })
Object.defineProperty(Vue.prototype, '$cdn', {
  value: {
    giata: window.giataCdn,
    default: window.defaultCdn,
  },
})
Object.defineProperty(Vue.prototype, '$window', { value: window })
window.moment.locale(appLocale)
// window.moment.now = function () {
//     return new Date(2018, 9, 2);
// }
Object.defineProperty(Vue.prototype, '$moment', { value: window.moment })

var Vue2TouchEvents = require('vue2-touch-events')
Vue.use(Vue2TouchEvents)

var VueGoogleMaps = require('vue2-google-maps')
Vue.use(VueGoogleMaps, {
  load: {
    key: window.googleKey,
  },
})

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false
  Vue.config.debug = false
  Vue.config.silent = true
} else {
  Vue.config.devtools = true
}

var VueRouter = require('vue-router')
Vue.use(VueRouter)
var router = new VueRouter.default({
  mode: 'history',
  routes: [],
})

const app = new Vue({
  router,
  el: '#app',
  data() {
    return {
      accordions: [],
      windowWidth: 0,
      windowHeight: 0,
      windowScrollTop: 0,
      helper: null,
      toggleHelper: null,

      //Compare
      tripsInComparison: [],
    }
  },
  mounted: function () {
    $cookies.config(60 * 60 * 24 * 365, '')

    if ($cookies.get('tripsComparison') !== null)
      this.tripsInComparison = $cookies.get('tripsComparison').split(',')

    //Window resize
    var self = this
    $(window).on('resize', function () {
      self.windowWidth = window.innerWidth
      self.windowHeight = window.innerHeight
    })
    window.addEventListener('scroll', this.updateWindowScrollTop)
    $(window).resize()

    // Toggle helper
    if ($('div.booking-case.products div.tab-content').length > 0) {
      this.toggleHelper = $(
        'div.booking-case.products div.tab-content > div.tab-pane'
      )
        .first()
        .attr('id')
    }

    // Check for product in query
    if (typeof this.$route.query.product !== 'undefined') {
      var product = this.$route.query.product
      var input = $(
        'div.booking-case.products input[type=radio][value=' + product + ']'
      )

      if (input.length > 0) {
        var panelID = input.parents('div.tab-pane').attr('id')
        this.toggleHelper = panelID

        setTimeout(function () {
          input.prop('checked', true)
        }, 100)
      }
    }
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.updateWindowScrollTop)
  },
  computed: {},
  methods: {
    toggleAccordion: function (name) {
      var index = this.accordions.indexOf(name)
      if (index < 0) {
        this.accordions.push(name)
      } else {
        this.accordions.splice(index, 1)
      }
    },
    isActiveAccordion: function (name) {
      return this.accordions.indexOf(name) >= 0
    },
    updateWindowScrollTop: function () {
      this.windowScrollTop = $('html').scrollTop()
    },
  },
  watch: {
    tripsInComparison: function () {
      $cookies.set(
        'tripsComparison',
        this.tripsInComparison,
        365 * 10 * 24 * 60 * 60
      )
    },
    toggleHelper: function () {
      setTimeout(function () {
        if (
          $('div.booking-case.products input[type=radio]:visible').length > 0
        ) {
          $('div.booking-case.products input[type=radio]:visible')
            .first()
            .prop('checked', true)
        }
      }, 50)
    },
  },
})
